// extracted by mini-css-extract-plugin
export default {"RelativeTime":"Blame-module__RelativeTime--Rq9oy"};